import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Lottie from "lottie-react";
import { useNavigate } from "react-router-dom";

export default function ThankYouPage() {
  const navigate = useNavigate();
      const [animationData, setAnimationData] = useState(null);
      const [vector, setVector] = useState(null);
  
 useEffect(() => {
      fetch("/assests/lottie/animation.json")
        .then((res) => res.json())
        .then((data) => setAnimationData(data))
        .catch((err) => console.error("Error loading animation:", err));

        fetch("/assests/lottie/vector.json")
        .then((res) => res.json())
        .then((data) => setVector(data))
        .catch((err) => console.error("Error loading animation:", err));
    }, []);
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
      <motion.div
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="bg-white shadow-lg rounded-2xl p-8 max-w-2xl text-center flex flex-col items-center"
      >
        {/* Lottie Animation */}
        <motion.div
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="w-40 h-40"
        >
          <Lottie animationData={animationData}  loop={true} />
        </motion.div>

        {/* Text Section */}
        <motion.h2
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.5 }}
          className="text-3xl font-bold text-gray-800 mt-4"
        >
          Thank You!
        </motion.h2>
        <motion.div
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="w-40 h-40"
        >
          <Lottie animationData={vector}  loop={true} />
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          className="text-gray-600 mt-2 text-lg"
        >
          Your submission has been received. We will contact you soon!
        </motion.p>

        {/* CTA Button */}
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => navigate("/")}
          className="mt-6 bg-purple-600 hover:bg-purple-700 text-white py-3 px-6 rounded-lg text-lg transition duration-300"
        >
          Go to Homepage
        </motion.button>
      </motion.div>
    </div>
  );
}
